import { apiClient } from "lib/apiClient";
import {
  IResearchEditDemandRequest,
  IResearchWorkItem,
} from "features/Research/types";

export const editResearchDemand = async (
  workItemId: string,
  demandId: string,
  request: IResearchEditDemandRequest
): Promise<IResearchWorkItem> => {
  const response = await apiClient.put(
    `/research/work-items/${workItemId}/demands/${demandId}`,
    request
  );
  return response.data;
};
